﻿import { setVisibility } from "../helpers";
export function initValuationUploadPage() {

    initValuationTypeInputGroup();
    updateValuationInputsVisibility(true);
}

function initValuationTypeInputGroup() {
    const valuationTypeGroup = document.getElementById("ValuationTypeGroup");
    if (!valuationTypeGroup) {
        return;
    }

    const none = document.querySelector("div[data-form-field-name='ValuationType.ValuationType']:has(#ValuationType_ValuationType_None)");
    const desktopTaxation = document.querySelector("div[data-form-field-name='ValuationType.ValuationType']:has(#ValuationType_ValuationType_DesktopTaxation)");
    const desktopTaxationPlus = document.querySelector("div[data-form-field-name='ValuationType.ValuationType']:has(#ValuationType_ValuationType_DesktopTaxationPlus)");
    const validatedTaxationReport = document.querySelector("div[data-form-field-name='ValuationType.ValuationType']:has(#ValuationType_ValuationType_ValidatedTaxationReport)");
    const wozValue = document.querySelector("div[data-form-field-name='ValuationType.ValuationType']:has(#ValuationType_ValuationType_WOZValue)");

    setVisibility(none, false);
    setVisibility(desktopTaxationPlus, false);
    setVisibility(desktopTaxation, valuationTypeGroup.dataset.desktopTaxation == "True");
    setVisibility(validatedTaxationReport, valuationTypeGroup.dataset.validatedTaxationReport == "True");
    setVisibility(wozValue, valuationTypeGroup.dataset.wozValue == "True");

    desktopTaxation?.querySelector("input")?.addEventListener('change', updateValuationInputsVisibility);
    validatedTaxationReport?.querySelector("input")?.addEventListener('change', updateValuationInputsVisibility);
    wozValue?.querySelector("input")?.addEventListener('change', updateValuationInputsVisibility);
}

function updateValuationInputsVisibility(skipInputClearing=false) {
    const desktopTaxationSelected = document.getElementById("ValuationType_ValuationType_DesktopTaxation")?.checked === true;
    const validatedTaxationSelected = document.getElementById("ValuationType_ValuationType_ValidatedTaxationReport")?.checked === true;
    const wozValueSelected = document.getElementById("ValuationType_ValuationType_WOZValue")?.checked === true;

    document.querySelectorAll('[data-valuationType-desktopTaxation]:not([data-valuationType-validatedTaxation])').forEach(element => {
        setVisibility(element, desktopTaxationSelected);
    });

    document.querySelectorAll('[data-valuationType-validatedTaxation]:not([data-valuationType-desktopTaxation])').forEach(element => {
        setVisibility(element, validatedTaxationSelected);
    });

    document.querySelectorAll('[data-valuationType-desktopTaxation][data-valuationType-validatedTaxation]').forEach(element => {
        setVisibility(element, desktopTaxationSelected || validatedTaxationSelected);
    });

    document.querySelectorAll('[data-valuationType-wozValue]').forEach(element => {
        setVisibility(element, wozValueSelected);
    });

    if (!skipInputClearing) {
        document.querySelectorAll(
            'div[data-valuationType-desktopTaxation] input, ' +
            'div[data-valuationType-validatedTaxation] input, ' +
            'div[data-valuationType-wozValue] input'
        ).forEach(input => {
            input.value = '';
        });
    }
}